import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMobileServiceAppointmentsExportQueryVariables = Types.Exact<{
  customerId: Types.Scalars['Int']['input'];
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  orderBy?: Types.InputMaybe<Array<Types.Appointments_Order_By> | Types.Appointments_Order_By>;
  statusFilter?: Types.Appointments_Bool_Exp;
}>;


export type GetMobileServiceAppointmentsExportQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: number, source: string, appointment_time?: string | null, consumer_name?: string | null, consumer_phone?: string | null, ro_number?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: number | null, vehicle_vin?: string | null, vehicle_color?: string | null, status: string, driver_notes?: string | null, createdat: string, createdby: string, pickup?: { __typename?: 'locations', id: number, name?: string | null, address?: string | null } | null, service_orders: Array<{ __typename?: 'service_orders', id: number, stop: { __typename?: 'mobility_stops', id: number, stop_order: number, run: { __typename?: 'mobility_runs', id: number, status: string } } }> }> };


export const GetMobileServiceAppointmentsExportDocument = gql`
    query getMobileServiceAppointmentsExport($customerId: Int!, $start: timestamptz!, $end: timestamptz!, $orderBy: [appointments_order_by!], $statusFilter: appointments_bool_exp! = {}) {
  appointments(
    where: {_and: [$statusFilter], type: {_eq: "mobile_service"}, customer_id: {_eq: $customerId}, _or: [{appointment_time: {_gte: $start, _lte: $end}}, {appointment_time: {_is_null: true}}]}
    order_by: $orderBy
  ) {
    id
    source
    appointment_time
    consumer_name
    consumer_phone
    ro_number
    pickup {
      id
      name
      address
    }
    vehicle_make
    vehicle_model
    vehicle_year
    vehicle_vin
    vehicle_color
    status
    driver_notes
    createdat
    createdby
    service_orders {
      id
      stop {
        id
        stop_order
        run {
          id
          status
        }
      }
    }
  }
}
    `;

/**
 * __useGetMobileServiceAppointmentsExportQuery__
 *
 * To run a query within a React component, call `useGetMobileServiceAppointmentsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileServiceAppointmentsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileServiceAppointmentsExportQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      orderBy: // value for 'orderBy'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetMobileServiceAppointmentsExportQuery(baseOptions: Apollo.QueryHookOptions<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables> & ({ variables: GetMobileServiceAppointmentsExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>(GetMobileServiceAppointmentsExportDocument, options);
      }
export function useGetMobileServiceAppointmentsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>(GetMobileServiceAppointmentsExportDocument, options);
        }
// @ts-ignore
export function useGetMobileServiceAppointmentsExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>;
export function useGetMobileServiceAppointmentsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceAppointmentsExportQuery | undefined, GetMobileServiceAppointmentsExportQueryVariables>;
export function useGetMobileServiceAppointmentsExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>(GetMobileServiceAppointmentsExportDocument, options);
        }
export type GetMobileServiceAppointmentsExportQueryHookResult = ReturnType<typeof useGetMobileServiceAppointmentsExportQuery>;
export type GetMobileServiceAppointmentsExportLazyQueryHookResult = ReturnType<typeof useGetMobileServiceAppointmentsExportLazyQuery>;
export type GetMobileServiceAppointmentsExportSuspenseQueryHookResult = ReturnType<typeof useGetMobileServiceAppointmentsExportSuspenseQuery>;
export type GetMobileServiceAppointmentsExportQueryResult = Apollo.QueryResult<GetMobileServiceAppointmentsExportQuery, GetMobileServiceAppointmentsExportQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/getMobileServiceAppointmentsExport.query.gql}
 */
export async function getMobileServiceAppointmentsExport(
  variables: GetMobileServiceAppointmentsExportQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMobileServiceAppointmentsExportQuery['appointments']>
export async function getMobileServiceAppointmentsExport(
  variables: GetMobileServiceAppointmentsExportQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMobileServiceAppointmentsExportQuery>
export async function getMobileServiceAppointmentsExport(
  variables: GetMobileServiceAppointmentsExportQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMobileServiceAppointmentsExportQuery['appointments'] | GetMobileServiceAppointmentsExportQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMobileServiceAppointmentsExportQuery>(
    GetMobileServiceAppointmentsExportDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.appointments
}